"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("../_virtual/_tslib.js"),a=require("react/jsx-runtime"),i=require("styled-components"),s=require("@vds/buttons"),n=require("@vds/typography"),t=require("@vds/lines"),o=require("@vds/icons"),d=require("@vds-tokens/core"),l=require("@plans/blocks"),r=require("@plans/utilities"),p=require("@vds/badges"),c=require("../tile/index.js");function u(e){return e&&e.__esModule?e:{default:e}}var m=u(i);const f=m.default(c.default).withConfig({displayName:"StyledTile",componentId:"VDS__sc-f58qss-0"})`
  > div > div:last-of-type {
    padding: ${({padding:e})=>e||d.LayoutTokens.space["6X"].value};
  }
  @media (min-width: ${r.breakpoints.tabletSmall.min}) {
    > div > div:first-of-type {
      &:before {
        border-radius: ${({borderRadius:e})=>e||"32px"} !important;
      }
    }
    > div > div:last-of-type {
      border-radius: ${({borderRadius:e})=>e||"32px"} !important;
      padding: ${({padding:e})=>e||d.LayoutTokens.space["8X"].value};
    }
  }
`,g=m.default.div.withConfig({displayName:"LineBlockWrapper",componentId:"VDS__sc-f58qss-1"})`
  display: flex;
  flex-direction: row;
  width: 100%;
`,y=m.default.div.withConfig({displayName:"ContentWrapper",componentId:"VDS__sc-f58qss-2"})`
  display: flex;
  flex-direction: column;
  width: 100%;
`,x=m.default.span.withConfig({displayName:"ButtonWrapperMobile",componentId:"VDS__sc-f58qss-3"})`
  display: flex;
  padding-top: ${d.LayoutTokens.space["6X"].value};
  @media (min-width: ${r.breakpoints.tabletSmall.min}) {
    display: none;
  }
`,h=m.default.span.withConfig({displayName:"ButtonWrapperDesktop",componentId:"VDS__sc-f58qss-4"})`
  align-items: center;
  display: flex;
  padding-left: ${d.LayoutTokens.space["3X"].value};
  @media (max-width: 767.9px) {
    display: none;
  }
`,b=m.default.div.withConfig({displayName:"BadgeWrapper",componentId:"VDS__sc-f58qss-5"})`
  align-items: center;
  display: flex;
  flex-direction: row;
  padding-top: ${d.LayoutTokens.space["6X"].value};
`,k=m.default.div.withConfig({displayName:"BadgeTextWrapper",componentId:"VDS__sc-f58qss-6"})`
  margin-left: ${d.LayoutTokens.space["4X"].value};
`,v=m.default.div.withConfig({displayName:"PlanBlockWrapper",componentId:"VDS__sc-f58qss-7"})`
  display: flex;
  flex-direction: column;
  gap: ${d.LayoutTokens.space["4X"].value};
  padding-top: ${d.LayoutTokens.space["4X"].value};
  @media (min-width: ${r.breakpoints.tabletSmall.min}) {
    gap: ${d.LayoutTokens.space["6X"].value};
    padding-top: ${d.LayoutTokens.space["6X"].value};
  }
  width: 100%;
  > div {
    width: inherit;
  }
`,j=m.default.div.withConfig({displayName:"TextLinkMobileWrapper",componentId:"VDS__sc-f58qss-8"})`
  padding-top: ${d.LayoutTokens.space["6X"].value};
  @media (min-width: ${r.breakpoints.tabletSmall.min}) {
    display: none;
  }
`,_=m.default.div.withConfig({displayName:"TextLinkDesktopWrapper",componentId:"VDS__sc-f58qss-9"})`
  padding-top: ${d.LayoutTokens.space["6X"].value};
  @media (max-width: 767px) {
    display: none;
  }
`,w=m.default.div.withConfig({displayName:"TopBadgeWrapper",componentId:"VDS__sc-f58qss-10"})`
  padding-bottom: ${d.LayoutTokens.space["4X"].value};
  @media (min-width: ${r.breakpoints.tabletSmall.min}) {
    padding-bottom: ${d.LayoutTokens.space["6X"].value};
  }
`;exports.default=i=>{const{button:r,separator:c,listItem:u,plan:m,lineBlock:q,badge:L,backgroundColor:T="black",surface:$="light",textLink:C}=i,S=e.__rest(i,["button","separator","listItem","plan","lineBlock","badge","backgroundColor","surface","textLink"]),I=r&&a.jsx(s.Button,Object.assign({size:"small",use:"primary",width:"auto"},r));return a.jsx(f,Object.assign({width:"100%",height:"auto",background:d.ColorTokens.background.secondary[`${$||"light"}`].value,surface:"black"===T?"dark":"light"},S,{children:a.jsxs(y,{children:[L&&a.jsx(w,{children:a.jsx(p.Badge,Object.assign({fillColor:"green"},L))}),(q||r&&!m)&&a.jsxs(g,{children:[q&&a.jsx(l.Line,Object.assign({surface:$},q,{icon:void 0})),r&&!m&&a.jsx(h,{children:I})]}),u&&(()=>{const e=Object.assign({icon:{name:"checkmark-alt"}},u),i=u&&u.color||d.ColorTokens.elements.primary[`on${$||"light"}`].value;return a.jsxs(b,{children:[e&&e.icon&&e.icon.name&&a.jsx(o.Icon,Object.assign({name:e.icon.name,size:"large",color:i,ariaHidden:!0},e.icon)),a.jsx(k,{children:a.jsx(n.Body,Object.assign({size:"large",color:i},e,{children:e&&e.children}))})]})})(),C&&!m&&a.jsx(_,{children:a.jsx(s.TextLink,Object.assign({size:"large",type:"standAlone",surface:$},C))}),r&&!m&&a.jsx(x,{children:I}),C&&!m&&a.jsx(j,{children:a.jsx(s.TextLink,Object.assign({size:"small",type:"standAlone",surface:$},C))}),m&&a.jsxs(v,{children:[c&&a.jsx(t.Line,{type:"secondary",surface:$}),a.jsx(l.Plan,Object.assign({surface:$},m))]})]})}))};
